import React from 'react';
import { IActionContext } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const MfrCode = ({
    productInfo,
    actionContext,
    mfrCodeLabel
}: {
    productInfo?: SimpleProduct;
    actionContext: IActionContext;
    mfrCodeLabel: string;
}) => {
    const mfrCode = productInfo?.ExtensionProperties?.find(ep => ep.Key === 'MfrCode')?.Value?.StringValue;

    if (mfrCode) {
        return (
            <>
                {' '}
                {mfrCodeLabel}: {mfrCode}
            </>
        );
    }

    return null;
};

export { MfrCode };
